// Bootstraps the AppointmentBooking.SlotSuggester namespace so that model/
// view/collection files can reference it at module-evaluation time. Must be
// imported FIRST by index.js and by any file that touches
// AppointmentBooking.SlotSuggester.Events.* at module top level (e.g. in a
// `static { ... }` block, or views/reselector.js computed event keys).
//
// Uses per-key `??=` assignments so that if sub-module files evaluate before
// this file (due to Vite's eager glob expansion ordering), the namespace
// properties they already created are preserved rather than overwritten.
window.AppointmentBooking ??= {};

if (typeof window.AppointmentBooking.SlotSuggester !== "function") {
  window.AppointmentBooking.SlotSuggester = class SlotSuggester {
    constructor(...args) {
      // Delegate to _init which is defined in index.js.
      this._init(...args);
    }

    // Syntactic sugar for defining properties
    static get(propName, getter) {
      return Object.defineProperty(this.prototype, propName, { get: getter });
    }
  };
}

const SS = window.AppointmentBooking.SlotSuggester;
SS.Views ??= { Mixins: {} };
if (!SS.Views.Mixins) {
  SS.Views.Mixins = {};
}
SS.Collections ??= {};
SS.Models ??= {};
SS.Events ??= {
  providerList: {
    select: "providerList:select.sparkle",
  },
  slot: {
    confirm: "slot:confirm.sparkle",
  },
};
